import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import type { InspectionWithValues } from "../../models/Inspection";
import type { AverageRow } from "../../models/RollingSummary";

type Props = {
	onNew: () => void;
	onEdit: (row: InspectionWithValues) => void;
	onDelete: (row: InspectionWithValues) => void;
};

export const useInspectionOptionsFunctions = ({
	onNew,
	onEdit,
	onDelete,
}: Props) => {
	const getMenuOptions = (data: InspectionWithValues | AverageRow) => {
		let options: MenuOptionType[] = [
			{
				name: "New Inspection",
				key: "new_inspection",
				onClick: onNew,
				icon: <PlaylistAddIcon />,
			},
		];

		// The pinned average row is a summary, not a sample: nothing to edit or delete
		const sample =
			data && !(data as AverageRow).__average
				? (data as InspectionWithValues)
				: null;

		if (sample) {
			options = options.concat([
				{
					name: "Edit Inspection",
					key: "edit_inspection",
					onClick: () => onEdit(sample),
					icon: <EditIcon />,
				},
				{
					name: "Delete Inspection",
					key: "delete_inspection",
					onClick: () => onDelete(sample),
					icon: <DeleteIcon />,
				},
			]);
		}

		return options;
	};

	return { getMenuOptions };
};
